import React, { useState } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { Badge } from 'primereact/badge';
const OccupancyRate = (maxseats, currentseats, waitlistCount, occupancytype, almostFullWarning, tresh = 25, waitlist) => {
  return <div className="field">
    <small>{occupancytype}</small>
    <br />
    <div className='p-overlay-badge'>
      <ProgressBar
        mode={maxseats ? 'determinate' : 'indeterminate'}
        showValue={true}
        value={(currentseats / maxseats * 100)}
        displayValueTemplate={(value) => {
          if (value > tresh)
            return (
              <React.Fragment>
                {currentseats}/<b>{maxseats}</b>
              </React.Fragment>
            );
        }}
      />{waitlistCount > 0 && (
        <Badge
          value={"+" + waitlistCount}
          severity="warning"
          size="normal"
          className="absolute top-0 right-0 mr-2 mt-2"
        />)}
    </div>
    {
      ((currentseats / maxseats) > 0.9) &&
      <div>
        <i className='pi pi-exclamation-triangle'></i>&nbsp;
        <small>
          {almostFullWarning}
        </small>
      </div>}
  </div>
};
export default OccupancyRate;